import { Box, Flex, Typography } from "@jewlr/storybook/core"
import { Checkbox } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import { Controller } from "react-hook-form"
import styled from "styled-components"

import { ImgWrapper, ProductImg, Text } from "areas/order/components"

const FormError = styled.p`
  color: red;
  font-size: 12px;
`

const ChooseItem = ({
  control,
  errors,
  formType,
  items,
  lineItems,
  numEligibleItems,
}) => {
  const name = `${formType}Items`

  return (
    <>
      {numEligibleItems > 0 && (
        <Text mb={2}>
          Please select the item(s) you would like to {formType}:
        </Text>
      )}
      <Box
        display={{ _: "block", tablet: "flex" }}
        flexWrap="wrap"
        mb={{ _: 3, tablet: 2 }}
      >
        {lineItems.map((item, i) => (
          <Flex alignItems="center" flexBasis="50%" key={i} mb={2}>
            {item.error_message || item.has_in_progress_rma ? (
              <Box minHeight="16px" minWidth="16px" />
            ) : (
              <Controller
                control={control}
                name={name}
                render={({ field }) => (
                  <Checkbox
                    checked={items.includes(item.id)}
                    name={name}
                    onChange={(e) => {
                      if (e.target.checked) {
                        field.onChange([...items, item.id])
                      } else {
                        field.onChange(items.filter((i) => i != item.id))
                      }
                    }}
                  />
                )}
              />
            )}
            <ImgWrapper flexShrink="0" mx={2} width="150px">
              <ProductImg alt={item.title} src={item.image_url} />
            </ImgWrapper>
            <Box pr={{ tablet: 6 }}>
              <Text fontWeight="500">{item.title}</Text>
              {(item.error_message || item.has_in_progress_rma) && (
                <>
                  {item.error_message && (
                    <Text color="error" fontWeight="500">
                      {item.error_message}
                    </Text>
                  )}
                  {item.has_in_progress_rma && (
                    <Text color="error" fontWeight="500">
                      Your item has an RMA (Return Merchandise Authorization)
                      already in progress.
                    </Text>
                  )}
                  <Text fontWeight="500">
                    Please contact customer service at{" "}
                    <Typography
                      as="a"
                      href={`tel:${sl.config.customer_service_toll_free}`}
                    >
                      {sl.config.customer_service_toll_free}
                    </Typography>{" "}
                    or{" "}
                    <Typography
                      as="a"
                      href={`mailto:${sl.config.customer_service_email}`}
                    >
                      {sl.config.customer_service_email}
                    </Typography>{" "}
                    for assistance.
                  </Text>
                </>
              )}
            </Box>
          </Flex>
        ))}
      </Box>
      <FormError>{errors[name]}</FormError>
    </>
  )
}

ChooseItem.propTypes = {
  control: PropTypes.object,
  errors: PropTypes.object,
  formType: PropTypes.string,
  items: PropTypes.array,
  lineItems: PropTypes.array,
  numEligibleItems: PropTypes.number,
}

export default ChooseItem
